import { Dialog } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import IconButtonWrapper from "../../../common/form-fields-mui/IconButtonWrapper";
import AButton from "../../../common/form-fields-mui/AButton";
import { useGetCollectPaymentContext } from "../context";
import { formattedPrice } from "../utils";
import RupeeInput from "./RupeeInput";
import { validatePartialPayment } from "./validation";
import { useGetFeeConfiguration } from "../context/customHook";
import { numberDecimalLimitRegex } from "../selectPaymentMode/components/constant";

function PartialPaymentPopup({ open, setOpen }) {
  const {
    selectedChargesAmount,
    selectedCharges,
    setPartialPaymentAmount,
    studentBasicDetails,
  } = useGetCollectPaymentContext();
  const { feeConfiguration, loading, error } = useGetFeeConfiguration(
    studentBasicDetails?.academicCareerValue,
    studentBasicDetails?.bu
  );

  const [amount, setAmount] = useState("");
  const [errorMgs, setErrorMgs] = useState("");
  const closeHandler = () => {
    setOpen(false);
    setAmount("");
    setErrorMgs("");
  };
  //

  const addAmountHandler = () => {
    const error = validatePartialPayment(
      amount,
      selectedCharges,
      selectedChargesAmount,
      feeConfiguration
    );
    if (error) {
      setErrorMgs(error);
      return;
    }
    setPartialPaymentAmount(amount);
    closeHandler();
  };
  return (
    <>
      <Dialog onClose={closeHandler} open={open} maxWidth="lg">
        <div style={{ padding: "28px 24px", minWidth: "29rem" }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="color-dark heading-4">Partial Payment</div>
            <div>
              <IconButtonWrapper onClick={closeHandler}>
                <CrossIcon width={32} height={32} />
              </IconButtonWrapper>
            </div>
          </div>
          <div>Enter partial payment amount</div>
          <div className="d-flex align-item-center">
            <RupeeInput
              value={amount}
              onChange={(e) => {
                setAmount(e);
                setErrorMgs("");
              }}
              regex={numberDecimalLimitRegex(10, 2)}
              style={{ width: "250px", height: "46px" }}
            />
            <AButton
              updatedStyle={{ minWidth: "140px" }}
              onClick={addAmountHandler}
              variant="primary_filled"
            >
              Add Amount
            </AButton>
          </div>
          <div className="d-flex mt-4 w-100 justify-content-between text-bold color-dark">
            <div className=" heading-3">Total amount</div>
            <div>{formattedPrice(selectedChargesAmount)}</div>
          </div>
          {errorMgs && (
            <div className="d-flex align-items-center mt-3 gap-md">
              <div className="error-message-dot">!</div>
              <div style={{ maxWidth: "28rem" }} className="text-error-message">
                {" "}
                {errorMgs}
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
}

export default PartialPaymentPopup;
